import script from "./discount-code-banner.vue?vue&type=script&setup=true&lang=js"
export * from "./discount-code-banner.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__